// extracted by mini-css-extract-plugin
export default {"container":"Tooling_container__9I+Eg","tooling":"Tooling_tooling__auF1X","toolsBlock":"Tooling_toolsBlock__354NT","tool":"Tooling_tool__0oI0p","shadow":"Tooling_shadow__M5Y2T"};